<template>
	<div class="l-row--t64 l-row--t128l module desc">
		<div class="g-row" :class="{
			's--h-start': data.target.align == 0,
			's--h-end': data.target.align == 1,
		}">
			<div class="g-col--6 g-col--3s">
				<p class="t-b--18 t-b--16s i--en" v-html="data.target.body"></p>
				<p class="l-mdl--16 t-b--18 t-b--16s i--kr" v-html="data.target.bodyKo"></p>
			</div>
		</div>
	</div>
</template>

<script>
import * as _ from "fxjs";
import { computed, ref, reactive, useStore } from "@/helper/vue.js";
import Picture from "@/parts/picture/PictureView.vue";

export default {
  props: ["idx", "bindRoot"],
	components: {
		Picture
	},
  setup(props) {
    const { get } = useStore();
		const self = ref();
		const data = reactive({
			target: computed(() => get["from"](`${props.bindRoot}.modules.${props.idx}`)),
		});

    return {
			self,
			data,
    };
  },
};
</script>

<style scoped lang="scss"></style>